module.exports = __webpack_public_path__ + "img/Weapon_08.257aceb5.png";